module.exports = __webpack_public_path__ + "img/wave.0eb909fe.png";